import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, useLocation, Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import LoggedInLayout from "../layout";
import { ChangelogProvider } from "../context/Changelog/ChangelogContext";
import Dashboard from "../pages/Dashboard";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments"
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import GlobalAudioPlayer from "../components/GlobalAudioPlayer";
import { useAudioPlayer } from "../context/AudioPlayerContext";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault"
import CampaignsPhrase from "../pages/CampaignsPhrase";
import Subscription from "../pages/Subscription";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files";
import ToDoList from "../pages/ToDoList";
import TaskDashboard from "../pages/Tasks/TaskDashboard";
import TaskArchive from "../pages/TaskArchive";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import ChecklistTemplates from "../pages/ChecklistTemplates";
import Services from "../pages/Servicos";
import { Plantao } from '../pages/Plantao';
import PasswordReset from "../pages/PasswordReset";
import CustomCategoryFields from "../pages/CustomCategoryFields";
import ReleasesAdmin from "../pages/ReleasesAdmin";
const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Limpeza de toasts movida para dentro do LayoutWithGlobalPlayer (já dentro do Router)

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/recovery-password" component={PasswordReset} />
            <WhatsAppsProvider>
              <LayoutWithGlobalPlayer>
                <Route exact path="/financeiro" component={Financeiro} isPrivate />
                <Route exact path="/subscription" component={Subscription} isPrivate />
                <Route exact path="/companies" component={Companies} isPrivate />
                {/* Raiz sempre redireciona para tickets (padrão desejado) */}
                <Route exact path="/" component={() => <Redirect to="/tickets" />} isPrivate />
                <Route exact path="/dashboard" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/tasks" component={ToDoList} isPrivate />
                <Route exact path="/task-archive" component={TaskArchive} isPrivate />
                <Route exact path="/task-dashboard" component={TaskDashboard} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/contacts/import" component={ContactImportPage} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/messages-api" component={MessagesAPI} isPrivate />
                <Route exact path="/settings" component={SettingsCustom} isPrivate />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/announcements" component={Annoucements} isPrivate />
                <Route exact path="/phrase-lists" component={CampaignsPhrase} isPrivate />
                <Route exact path="/flowbuilders" component={FlowBuilder} isPrivate />
                <Route exact path="/flowbuilder/:id?" component={FlowBuilderConfig} isPrivate />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/notifyMe" component={Plantao} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/moments" component={ChatMoments} isPrivate />
                <Route exact path="/Kanban" component={Kanban} isPrivate />
                <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/checklists/modelos" component={ChecklistTemplates} isPrivate />
                <Route exact path="/servicos" component={Services} isPrivate />
                <Route exact path="/custom-category-fields" component={CustomCategoryFields} isPrivate />
                <Route exact path="/releases-admin" component={ReleasesAdmin} isPrivate requireSuper />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/allConnections" component={AllConnections} isPrivate />
                {showCampaigns && (
                  <>
                    <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                    <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                    <Route exact path="/campaigns" component={Campaigns} isPrivate />
                    <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                    <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                  </>
                )}
              </LayoutWithGlobalPlayer>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-right" autoClose={3000} style={{ top: 72 }} limit={3} newestOnTop />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

// Componente para exibir o GlobalAudioPlayer somente fora das telas de chat
const LayoutWithGlobalPlayer = ({ children }) => {
  const location = useLocation();
  const player = useAudioPlayer();
  // Limpa toasts a cada navegação para evitar mensagens antigas penduradas
  useEffect(() => {
    try { toast.dismiss(); } catch (_) {}
  }, [location.pathname]);
  const path = location.pathname || "";

  const ticketsMatch = path.match(/^\/tickets\/(.+)$/);
  const chatsMatch = path.match(/^\/chats\/(.+)$/);
  const onTickets = path.startsWith("/tickets");
  const onChats = path.startsWith("/chats");
  const routeId = (ticketsMatch && ticketsMatch[1]) || (chatsMatch && chatsMatch[1]) || null;

  const currentTrack = player?.currentTrack;
  const trackRouteId = currentTrack?.ticketRouteId || null;
  const trackTicketUuid = currentTrack?.ticketUuid || null;
  const trackTicketId = currentTrack?.ticketId != null ? String(currentTrack.ticketId) : null;

  // Oculta apenas se estiver na MESMA conversa do áudio atual
  let hideGlobal = false;
  if (currentTrack && routeId && (onTickets || onChats)) {
    hideGlobal = routeId === (trackRouteId || trackTicketUuid || trackTicketId);
  }

  return (
    <ChangelogProvider>
      <LoggedInLayout>
        {children}
        {!hideGlobal && <GlobalAudioPlayer />}
      </LoggedInLayout>
    </ChangelogProvider>
  );
};

export default Routes;
